import { Injectable } from '@angular/core';
import { LoggerService } from '@app/blocks/logger/services/logger.service';
import { Subject } from 'rxjs/internal/Subject';
import { ApplicationFormDataService } from './application-form-data.service';
import { firstValueFrom } from 'rxjs';
import { UtilityService } from '@app/shared/services/utility/utility.service';
import { DataService } from '@app/core/services/data.service';

@Injectable({
    providedIn: 'root'
})
export class ApplicationFormService {

    constructor(
        private logger: LoggerService,
        private afDataService: ApplicationFormDataService,
        private utilityService: UtilityService,
        private dataService: DataService,
    ) {
    }

    refDataSubject = new Subject();

    leadSubject = new Subject();
    subject = new Subject();
    residentsSubject = new Subject();
    affordabilitySubject = new Subject();
    safeguardingSubject = new Subject();
    referencesSubject = new Subject();
    jointReferencesSubject = new Subject();

    refDataModel: any = [];

    leadModel: any = {};
    jointModel: any = {};
    residentsModel: any = {};
    affordabilityModel: any = {};
    safeguardingModel = {};
    referencesModel: any = {};
    jointReferencesModel: any = {};

    // residentsRefDataModel = {}; ** not used **
    // refereesRefDataModel = {}; ** not used **
    // residentsRefDataSubject = new Subject(); ** not used **
    // refereesRefDataSubject = new Subject(); ** not used **
    // affordabilityRefDataSubject = new Subject();  ** not used **

    formState = {
        "progress": {
            "applicantComplete": false,
            "residentsComplete": false,
            "jointApplicantComplete": false,
            "affordabilityComplete": false,
            "safeguardingComplete": false,
            "referencesComplete": false,
            "jointReferencesComplete": false,
            "termsComplete": false
        }
    };

    jointApplication = {
        "enabled": false
    };

    active: any = {
        "active": "applicant" // applicant, joint, residents, references, terms, jointReferences, affordability, safeguarding
    };

    // back slide functionality
    goBack(currentSlide: string) {
        if (currentSlide === 'joint') {
            this.active.active = 'applicant'; // set new active slide
        }
        if (currentSlide === 'residents' && this.jointApplication.enabled) {
            this.active.active = 'joint';
        }
        if (currentSlide === 'residents' && !this.jointApplication.enabled) {
            this.active.active = 'applicant';
        }
        if (currentSlide === 'affordability') {
            this.active.active = 'residents';
        }
        if (currentSlide === 'safeguarding') {
            this.active.active = 'affordability';
        }
        if (currentSlide === 'references') {
            this.active.active = 'safeguarding';
        }
        if (currentSlide === 'jointReferences') {
            this.active.active = 'references';
        }
        if (currentSlide === 'terms' && this.jointApplication.enabled) {
            this.active.active = 'jointReferences';
        }
        if (currentSlide === 'terms' && !this.jointApplication.enabled) {
            this.active.active = 'references';
        }
    }

    // // next slide functionality, called via onSubmit when form is valid
    goForward(currentSlide: string) {
        this.logger.info("application-form.service :: goForward :: currentSlide " + currentSlide);

        if (currentSlide === 'applicant' && this.jointApplication.enabled) {
            firstValueFrom(this.afDataService.getJointApplicant(this.leadModel.applicationId))
                .then((response: any) => {
                    this.logger.info('applicationContactAddressId', response.applicationContactAddressId);
                    this.dataService.ensureNationalityIsInShortList(this.refDataModel, response.jointApplicantNationality);
                    this.setJointModel(response);
                    // scroll(active.active, $timeout, $document, $location); TODO
                });

            this.active.active = 'joint';
        }

        if ((currentSlide === 'applicant' && !this.jointApplication.enabled) || (currentSlide === 'joint')) {
            firstValueFrom(this.afDataService.getAdditionalResidents(this.leadModel.applicationId))
                .then((response) => {
                    this.logger.info('goForward residents slide model', response);
                    this.setResidentsModel(response);
                    // scroll(active.active, $timeout, $document, $location);
                });

            this.active.active = 'residents';
        }

        if (currentSlide === 'residents') {
            firstValueFrom(this.afDataService.getAffordability(this.leadModel.applicationId))
                .then((response) => {
                    this.logger.info('goForward affordability slide model', response);
                    this.setAffordabilityModel(response);
                    // scroll(active.active, $timeout, $document, $location);
                });

            this.active.active = 'affordability';
        }

        if (currentSlide === 'affordability') {
            firstValueFrom(this.afDataService.getSafeguarding())
                .then((response) => {
                    this.logger.info('goForward safeguarding slide model', response);
                    this.setSafeguardingModel(response);
                    // scroll(active.active, $timeout, $document, $location);
                });

            this.active.active = 'safeguarding';
        }

        if (currentSlide === 'safeguarding') {
            firstValueFrom(this.afDataService.getReferences(this.leadModel.applicationId))
                .then((response) => {
                    this.logger.info('goForward references slide model', response);
                    this.setReferencesModel(response);
                    // scroll(active.active, $timeout, $document, $location);
                });

            this.active.active = 'references';
        }

        if (currentSlide === 'references' && !this.jointApplication.enabled) {
            this.active.active = 'terms';
        }

        if (currentSlide === 'references' && this.jointApplication.enabled) {
            firstValueFrom(this.afDataService.getJointReferences(this.leadModel.applicationId))
                .then((response) => {
                    this.logger.info('goForward joint references slide model', response);
                    this.setJointReferencesModel(response);
                    // scroll(active.active, $timeout, $document, $location);
                });

            this.active.active = 'jointReferences';
        }

        if (currentSlide === 'jointReferences') {
            this.active.active = 'terms';
        }

        if (currentSlide === 'terms') {
            this.active.active = null;
        }
    }

    debugSlide() {
        // firstValueFrom(this.afDataService.getJointApplicant(this.leadModel.applicationId))
        //     .then((response: any) => {
        //         this.logger.info('applicationContactAddressId', response.applicationContactAddressId);
        //         this.dataService.ensureNationalityIsInShortList(this.refDataModel, response.jointApplicantNationality);
        //         this.setJointModel(response);
        //         firstValueFrom(this.afDataService.getJointReferences(this.leadModel.applicationId))
        //             .then((response) => {
        //                 console.log(response)
        //                 this.setJointReferencesModel(response);
        //             });

        //         // scroll(active.active, $timeout, $document, $location); TODO
        //     });

        // this.active.active = 'jointReferences';
    }

    // scroll(activeSlide, $timeout, $document, $location) {

    // }

    addAddressIds(type: string) {
        if (type === "lead") {
            this.logger.info('addAddressIds leadModel', this.leadModel);

            // Current Address
            if (this.leadModel.applicationContactAddressId === null || this.leadModel.applicationContactAddressId === "") {
                this.leadModel.applicationContactAddressId = this.utilityService.newGuid();
            }

            // Previous Addresses
            if (this.leadModel.previousAddresses && this.leadModel.previousAddresses[ 0 ] !== undefined && this.leadModel.previousAddresses[ 0 ] !== null) {
                const addresses: any = [];

                this.leadModel.previousAddresses.forEach((address: any) => {

                    const uniqueAddress = address;
                    if (!uniqueAddress.applicationContactAddressId) {
                        uniqueAddress.applicationContactAddressId = this.utilityService.newGuid();
                    }

                    addresses.push(uniqueAddress)
                });

                this.leadModel.previousAddresses = addresses;
            }

            this.logger.info('addAddressIds lead processed', this.leadModel);

        }
        else {
            this.logger.info('addAddressIds jointModel', this.jointModel);

            // Current Address
            if (this.jointModel.applicationContactAddressId === null || this.jointModel.applicationContactAddressId === "") {
                this.logger.info('>> changing applicationContactAddressId <<');
                this.jointModel.applicationContactAddressId = this.utilityService.newGuid();
            }

            // Previous Addresses
            if (this.jointModel.jointApplicantPreviousAddresses && this.jointModel.jointApplicantPreviousAddresses[ 0 ] !== undefined) {
                this.logger.info('joint previous addresses processing');

                const addresses: any = [];

                this.jointModel.previousAddresses.forEach((address: any) => {

                    const uniqueAddress = address;
                    if (!uniqueAddress.applicationContactAddressId) {
                        uniqueAddress.applicationContactAddressId = this.utilityService.newGuid();
                    }

                    addresses.push(uniqueAddress)
                });

                this.jointModel.previousAddresses = addresses;
            }

            this.logger.info('addPreviousAddressIds processed', this.jointModel);
        }
    }

    addResidentIds() {
        this.logger.info('addResidentIds start', this.residentsModel);

        if (this.residentsModel.additionalResidents && this.residentsModel.additionalResidents[ 0 ] !== null) {
            const residents: any = [];

            this.residentsModel.additionalResidents.forEach((resident: any) => {

                if (!resident.additionalResidentsId) {
                    this.logger.info('generating additionalResidentsId Guid');
                    resident.additionalResidentsId = this.utilityService.newGuid();
                    resident.applicationId = this.leadModel.applicationId;
                }

                residents.push(resident);
            });

            this.residentsModel.additionalResidents = residents;
        }

        this.logger.info('addResidentIds processed', this.residentsModel);
    }

    isComplete(slide: string) {
        let result = false;

        if (slide === 'applicant') {
            result = this.formState.progress.applicantComplete;
        }

        this.logger.info('isComplete ' + result);

        return result;
    }

    getActive() {
        console.log(this.active);
        return this.active;
    }

    setActive(slide: string) {
        this.active.active = slide;
    }

    getJointApplication() {
        return this.jointApplication;
    }

    setJointApplication(data: any) {
        Object.assign(this.jointApplication, data);
    }

    getFormState() {
        return this.formState;
    }

    setFormState(data: any) {
        Object.assign(this.formState, data);
    }

    getJointModel() {
        return this.jointModel;
    }

    setJointModel(data: any) {
        this.logger.info('setJointModel called', data);
        this.jointModel = data;
        this.logger.info('jointModel', this.jointModel)
        this.subject.next(data);
    }

    subscribeJointModel(obj: any) {
        return this.subject.subscribe(obj);
    }

    getLeadModel() {
        return this.leadModel;
    }

    setLeadModel(data: any) {
        this.logger.info('setLeadModel called');
        this.leadModel = data;
        this.logger.info('leadModel', this.leadModel);
        this.leadSubject.next(data);
    }

    subscribeLeadModel(obj: any) {
        return this.leadSubject.subscribe(obj);
    }

    getResidentsModel() {
        return this.residentsModel;
    }

    setResidentsModel(data: any) {
        this.logger.info('setResidentsModel called', data);
        this.residentsModel = data;
        this.logger.info('residentsModel', this.residentsModel);
        this.residentsSubject.next(data);
    }

    subscribeResidentsModel(obj: any) {
        return this.residentsSubject.subscribe(obj);
    }

    getAffordabilityModel() {
        return this.affordabilityModel;
    }

    setAffordabilityModel(data: any) {
        this.logger.info('setAffordabilityModel called', data);
        this.affordabilityModel = data;
        this.logger.info('affordabilityModel', this.affordabilityModel);
        this.affordabilitySubject.next(data);
    }

    subscribeAffordabilityModel(obj: any) {
        return this.affordabilitySubject.subscribe(obj);
    }


    getSafeguardingModel() {
        return this.safeguardingModel;
    }

    setSafeguardingModel(data: any) {
        this.logger.info('setSafeguardingModel called', data);
        this.safeguardingModel = data;
        this.logger.info('safeguardingModel', this.safeguardingModel);
        this.safeguardingSubject.next(data);
    }

    subscribeSafeguardingModel(obj: any) {
        this.logger.info('subscribeRefDataModel');
        return this.safeguardingSubject.subscribe(obj);
    }

    getReferencesModel() {
        return this.referencesModel;
    }

    setReferencesModel(data: any) {
        this.logger.info('setReferencesModel called', data);
        this.referencesModel = data;

        this.referencesModel.referenceOneApplicantId = this.leadModel.id;
        this.referencesModel.referenceTwoApplicantId = this.leadModel.id;

        if (this.referencesModel.referenceOneApplicationRefereeId === null) {
            this.referencesModel.referenceOneApplicationRefereeId = this.utilityService.newGuid();

        }
        if (this.referencesModel.referenceTwoApplicationRefereeId === null) {
            this.referencesModel.referenceTwoApplicationRefereeId = this.utilityService.newGuid();
        }

        this.logger.info('referencesModel', this.referencesModel);
        this.referencesSubject.next(data);
    }

    subscribeReferencesModel(obj: any) {
        return this.referencesSubject.subscribe(obj);
    }

    getJointReferencesModel() {
        return this.jointReferencesModel;
    }

    setJointReferencesModel(data: any) {
        this.logger.info('setJointReferencesModel called', data);
        this.jointReferencesModel = data;

        console.log('---THIS JOINT MODEL---')
        console.log(this.jointReferencesModel)

        this.jointReferencesModel.referenceOneApplicantId = this.jointModel.applicationContactId;
        this.jointReferencesModel.referenceTwoApplicantId = this.jointModel.applicationContactId;

        if (this.jointReferencesModel.referenceOneApplicationRefereeId === null) {
            this.jointReferencesModel.referenceOneApplicationRefereeId = this.utilityService.newGuid();

        }
        if (this.jointReferencesModel.referenceTwoApplicationRefereeId === null) {
            this.jointReferencesModel.referenceTwoApplicationRefereeId = this.utilityService.newGuid();
        }

        this.logger.info('jointReferencesModel', this.jointReferencesModel);
        this.jointReferencesSubject.next(data)
    }

    subscribeJointReferencesModel(obj: any) {
        return this.jointReferencesSubject.subscribe(obj);
    }

    getRefDataModel() {
        return this.refDataModel;
    }

    setRefDataModel(data: any) {
        this.logger.info('setRefDataModel called');
        this.refDataModel = data;
        this.logger.info('setRefDataModel result', this.refDataModel);
        this.refDataSubject.next(data);
    }

    subscribeRefDataModel(obj: any) {
        this.logger.info('subscribeRefDataModel');
        return this.refDataSubject.subscribe(obj);
    }

    // * not used * //
    // getResidentsRefDataModel() {
    //     this.logger.info('getResidentsRefDataModel called', this.residentsRefDataModel);
    //     return this.residentsRefDataModel;
    // }

    // setResidentsRefDataModel(data: any) {
    //     this.logger.info('setResidentsRefDataModel called');
    //     this.residentsRefDataModel = data;
    //     this.logger.info('setResidentsRefDataModel result', this.residentsRefDataModel);
    //     this.residentsRefDataSubject.next(data);
    // }

    // subscribeResidentsRefDataModel(obj: any) {
    //     return this.residentsRefDataSubject.subscribe(obj);
    // }

    // getRefereesRefDataModel() {
    // }

    // setRefereesRefDataModel() {
    // }

    // subscribeRefereesRefDataModel(bj) {
    // }

    // residentsBST() {

    // }
    // * not used * //
}
